module.exports = __webpack_public_path__ + "img/katarina_outside_12.2e87e3bb.jpg";